import { render, staticRenderFns } from "./pcRefForms.vue?vue&type=template&id=e9817b9a&scoped=true&"
import script from "./pcRefForms.vue?vue&type=script&lang=js&"
export * from "./pcRefForms.vue?vue&type=script&lang=js&"
import style0 from "./pcRefForms.vue?vue&type=style&index=0&id=e9817b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9817b9a",
  null
  
)

export default component.exports